const HIDE = 'hide';
const REDIRECT = 'redirect';

export {
    HIDE,
    REDIRECT
};
